import { shippingInfoStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { css } from "styled-components";

styles.warningSection = {
    css: css`
        display: none;
    `,
};
